<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل منطقة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/regionsview">المناطق</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل منطقة</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="loader" class="text-center">
          <mainLoader />
        </div>

        <div v-if="!loader" class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown mx-2">
              <i class="bi bi-pencil-square mx-2 text-brown"></i>تعديل منطقة
            </h5>
            <div class="card">
              <div v-if="successfuly" class="pt-3 text-center">
                <successAlert :message= "message" />
              </div>
              <div class="card-body">
                <errorAlert v-if="regionError" :alertMessage= "message" />
                <form action="" @submit.prevent="regionUpdate">
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">الاسم - عربي</label>
                      <input type="text" class="form-control" v-model="regionName">
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">الاسم - إنجليزي</label>
                      <input type="text" class="form-control" v-model="nameEn">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">خط العرض (latitude)</label>
                      <input type="number" class="form-control" v-model="latitude" step="0.000001">
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">خط الطول (longitude)</label>
                      <input type="number" class="form-control" v-model="longitude" step="0.000001">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">الصورة - عربي</label>
                      <input type="file" class="form-control" 
                      @change="onFileAdd($event.target.files)">
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">الصورة - انجليزي</label>
                      <input type="file" class="form-control" 
                      @change="onFileAddEn($event.target.files)">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <img v-if="coverimg" :src="BASE_URL+'uploads/'+coverimg" class="img-fluid" alt="">
                    </div>
                    <div class="col-12 col-sm-6">
                      <img v-if="coverEn" :src="BASE_URL+'uploads/'+coverEn" class="img-fluid" alt="">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">كود هيئة العقار:</label>
                      <input type="text" class="form-control" v-model="regaId" />
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">الحاله</label>
                      <select class="form-control" v-model="status">
                        <option :value="true">نشط</option>
                        <option :value="false">غير نشط</option>
                      </select>
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12">
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="maintenanceAvailable"
                          v-model="maintenanceAvailable"
                        >
                        <label class="form-check-label" for="maintenanceAvailable">
                         هل الصيانة متاحة في هذه المنطقة ؟
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col text-center">
                      <loader v-if="isLoading" />
                      <button v-else type="submit" class="btn btn-success">إرسال</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name:'regionsupdate',
  data(){
    return {
      regions_id: this.$route.params.id,
      loader: false,
      regionError: false,
      message: '',
      regionName: "",
      nameEn: "",
      isLoading: false,
      status: true,
      successfuly: false,
      longitude: "",
      latitude: "",
      coverimg: "",
      coverEn: null,
      regaId: null,
      maintenanceAvailable: true,
    }
  },
  computed:{
    ...mapGetters(['BASE_URL'])
  },
  methods:{
    region_get_Data() {
      this.regionError = false;
      this.loader = true;
      this.$http.get(`/api/admin/regions/retrieve/${this.regions_id}`).then(res => {
        // console.log(res);
        this.loader = false;
        this.regionName = res.data.region.name;
        this.nameEn = res.data.region.nameEn;
        this.longitude = res.data.region.longitude;
        this.latitude = res.data.region.latitude;
        this.coverimg = res.data.region.cover;
        this.coverEn = res.data.region.coverEn;
        this.status = res.data.region.isActive;
        this.regaId = res.data.region.regaId;
        this.maintenanceAvailable = res.data.region.maintenanceAvailable ?? true;
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.regionError = true;
        this.loader = false;
        window.scroll(0,0);
      })
    },

    regionUpdate(){
      this.successfuly = false;
      this.regionError = false;
      this.isLoading = true;
      const formData = new FormData();
      formData.append('name',this.regionName);
      formData.append('nameEn',this.nameEn);
      formData.append('latitude',this.latitude);
      formData.append('longitude',this.longitude);
      formData.append('isActive',this.status);
      if(this.coverimg != '')
        formData.append('cover',this.coverimg);
      if(this.coverEn)
        formData.append('coverEn', this.coverEn);
      if(this.regaId)
        formData.append('regaId', this.regaId);
      formData.append('maintenanceAvailable', this.maintenanceAvailable);
      this.$http.put(`/api/admin/regions/update/${this.regions_id}`, formData).then(res => {
        this.coverimg = res.data.region.cover;
        this.coverEn = res.data.region.coverEn;
        this.isLoading = false;
        this.message = "تم التعديل بنجاح";
        this.successfuly = true;
        // this.$router.push({ name:'regionsview'});
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.regionError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },
    onFileAdd(files){
      this.coverimg = files[0];
    },
    onFileAddEn(files){
      this.coverEn = files[0];
    },
  },
  created() {
    this.region_get_Data();
  }
}
</script>